<template>
  <div>
    <div class="container">
      <div class="container-no-top-bottom">
        <div class="columns">
          <div class="column is-2">
            <div>
              <img
                alt="Vue logo"
                src="../../../assets/travessia_logo.png"
                width="220px"
                height="70px"
              >
            </div>
          </div>
          <div class="column is-1 input-margin">
            <label for class="filter-label">Filtro:</label>
          </div>
          <div class="column is-3 input-margin">
            <v-select
              class="background-select"
              v-model="filterOne"
              :options="[{label:'UFPA',value:'ufpa'},{label: 'UFRJ', value:'ufrj'}]"
            ></v-select>
          </div>
          <div class="column is-3 input-margin">
            <v-select
              class="background-select"
              v-model="filterTwo"
              :options="[{label:'Mais antigo',value:'antigo'},{label: 'Recentemente', value:'recentemente'}]"
            ></v-select>
          </div>
          <div class="column is-3 input-margin">
            <t-input :placeholder="'Pesquise'" :name="'login'" :classIcon="'fas fa-search'"/>
          </div>
        </div>
      </div>
      <section>
        <div class="container-no-top-bottom mt-xs-5 mt-sm-2 mt-md-3 mt-lg-1 mt-xl-1">
          <div class="h3-padding-bottom">
            <h3 class="h3-section">Redações aguardando correções</h3>
          </div>
          <div class="columns is-multiline">
            <t-box
              v-for="essay in essaysOutstanding"
              :key="essay.id"
              :title="essay.title"
              :description="essay.theme"
              class="column is-3"
            >
              <div class="columns is-mobile text-center mt-4">
                <div class="column">
                  <t-button size="md" color="success">Editar</t-button>
                </div>
                <div class="column">
                  <t-button size="md" color="danger">Excluir</t-button>
                </div>
              </div>
            </t-box>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import TInput from '@/components/TInput.vue'
import TButton from '@/components/TButton.vue'
import TBox from '@/components/TBox.vue'
export default {
  name: 'HelloWorld',
  components: {
    TInput,
    TButton,
    TBox
  },
  data () {
    return {
      valueWidthBox: 294,
      essaysOutstanding: [
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        },
        {
          theme: 'Teste',
          title: 'Titulo'
        }
      ],
      filterOne: 'INSTITUIÇÃO',
      filterTwo: 'PERÍODO',
      categories: []
    }
  }
}
</script>

<style scoped>
.container-background {
  height: 100%;
}

.filter-label {
  font-size: 25px;
  font-weight: 600;
}

.h3-section {
  font-size: 25px;
  font-weight: 600;
}
/* BOX */
.h3-padding-bottom {
  padding-bottom: 1rem;
}
.input-margin {
  margin-top: 1em;
}
@media screen and (min-width: 320px) and (max-width: 768px) {
  .input-margin {
    margin-top: 0;
  }
}
</style>
